export default {"src":"/_next/static/media/500-light.50cd2268.svg","height":1001,"width":729,"blurWidth":0,"blurHeight":0};